__webpack_require__.p = "/wp-content/plugins/wb-booking-frontend/dist/";